export default __webpack_public_path__ + "static/media/19-460x460.b6ee0217.jpeg";